import { render, staticRenderFns } from "./SocialPostsListHeader.vue?vue&type=template&id=3960f5cb&scoped=true&"
import script from "./SocialPostsListHeader.vue?vue&type=script&lang=js&"
export * from "./SocialPostsListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960f5cb",
  null
  
)

export default component.exports